export default class DynamicColors {
  constructor() {
    /**
     * @type {String}
     */
    this.modifierBaseName = 'dynamic-color';

    /**
     * @type {Number}
     */
    this.iterator = 0;

    this.generateModifier = this.generateModifier.bind(this);
  }

  /**
   * @return {String}
   */
  generateModifier() {
    this.iterator += 1;

    if (this.iterator >= 8) {
      this.iterator = 1;
    }

    return `${this.modifierBaseName}-${this.iterator}`;
  }
}
